var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: {
              "max-width": "300",
              type: "list-item, list-item, list-item",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "v-list",
            _vm._l(_vm.getRooms, function (room) {
              return _c(
                "v-list-item",
                { key: room.id },
                [
                  _c("SoliBtn", {
                    staticClass: "mb-3",
                    attrs: {
                      block: "",
                      text: room.display ?? room.title,
                      icon:
                        room.id == _vm.assignmentRoomId ? "assignment" : null,
                      color: "soli-grey",
                      outlined: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("input", room)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }